import axios from "axios";
import { authHeader } from "../helpers/auth-header";

const getHilightTableRequest = (url, params) => {
    return axios.get(url, { headers: authHeader(), params: params})
        .then((res) => {
            return res.data
        });
};

export const hilightTableAdvancedService = {
    getHilightTableRequest
};
